import { Button, Stack } from '@mui/material';
import React, { Dispatch, SetStateAction, useState } from 'react';
import MarkInterviewModal from '../MarkInterviewModal/MarkInterviewModal';
import { Application } from '@features/applications/types';

function MarkInterviewCTAs({
  application,
  column,
  setApplicationData,
  setApplication,
  setIsMessagingModalOpen,
  handleCTAs
}: {
  column?: boolean;
  application: Application;
  setApplicationData?: Dispatch<SetStateAction<Application[] | null>>;
  setApplication?: Dispatch<SetStateAction<Application | null>>;
  setIsMessagingModalOpen: Dispatch<SetStateAction<boolean>>;
  handleCTAs?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, type: 'completed' | 'missed') => void
}) {
  const [showInterviewRespondModal, setShowInterviewRespondModal] = useState<
    'completed' | 'missed' | ''
  >('');
  const handleInterviewRespond = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, type: 'completed' | 'missed') => {
    e.stopPropagation();
    e.preventDefault();
    handleCTAs && handleCTAs(e, type);
    setShowInterviewRespondModal(type);
  };
  return (
    <Stack
      direction={column ? 'column' : { xs: 'column', sm: 'row' }}
      spacing={2}
      gap={1}
      sx={{
        ...(column && {
          width: '80%',
          justifyContent: 'end',
          alignItems: 'end',
        }),
      }}
    >
      <Button
        onClick={(e) => handleInterviewRespond(e, 'completed')}
        color="success"
        size="small"
        variant="outlined"
        sx={{
          ...(column && {
            width: '180px',
          }), fontSize: '12px', whiteSpace: 'nowrap' }}
      >
        Mark as Interview Completed
      </Button>
      <Button
        onClick={(e) => handleInterviewRespond(e, 'missed')}
        color="secondary"
        size="small"
        variant="outlined"
        sx={{
          ...(column && {
            width: '180px',
          }), fontSize: '12px', whiteSpace: 'nowrap' }}
      >
        Mark as Interview Missed
      </Button>
      {!column && (
        <MarkInterviewModal
          handleClose={() => setShowInterviewRespondModal('')}
          isOpen={Boolean(showInterviewRespondModal)}
          type={showInterviewRespondModal}
          application={application}
          setApplicationData={setApplicationData}
          setApplication={setApplication}
          setIsMessagingModalOpen={setIsMessagingModalOpen}
        />
      )}
    </Stack>
  );
}

export default MarkInterviewCTAs;
